import React from 'react';
import Button from '@material-ui/core/Button';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import { baseTheme } from '../../../theme';
import TermsConditionsPage from '../../../pages/terms-conditions-page';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        margin: '15vh auto',
        borderRadius: '10px',
      },
    }),
);

interface ITermsAndConditionsModalProps {
  closeModal: () => void;
  title: string;
}

export default function TermsAndConditionsModal(props: ITermsAndConditionsModalProps) {
  const classes = useStyles(baseTheme);
  const { closeModal } = props;
  return (
      <div className={classes.root}>
          <Button onClick={closeModal}>Close</Button>
          <TermsConditionsPage/>
          <Button onClick={closeModal}>Close</Button>
      </div>
  );
}
